<div [ngClass]="getCSS()">
  <app-sidemenu [ripple]="showToggle" [toggleChecked]="toggleChecked"></app-sidemenu>
  <div class="sidebar-bottom">
    @if (showToggle) {
      <div class="sidebar-bottom__item" (click)="onTogglePanel()" matTooltip="Toggle sidebar" matTooltipPosition="right">
        <span class="material-icons sidebar-bottom__icon" translate="no">{{ toggleChecked ? 'chevron_right' : 'chevron_left' }}</span>
        <span class="sidebar-bottom__label">Toggle</span>
      </div>
    }
    @if (shouldShowInfoIcon) {
      <div class="sidebar-bottom__item" (click)="onReopenPopup()" matTooltip="Click to view important message" matTooltipPosition="right">
        <span class="material-icons sidebar-bottom__icon" translate="no">info</span>
        <span class="sidebar-bottom__label">Info</span>
      </div>
    }
    <app-user></app-user>
    <app-sidebar-logo></app-sidebar-logo>
  </div>
</div>
